import {
  compose,
  withPropsOnChange,
} from 'recompose'

import * as R from 'ramda'

import { toirIssuesApiActions, TOIR_ISSUES_SCHEMA_NAME } from 'api/toirIssues'
import { toirIssueTypesTransport, toirIssueTypesDataPropName } from './toirIssueTypesTransport'
import { toirStatusesTransport, toirStatusesDataPropName } from './toirStatusesTransport'
import prepareToirIssueForWidget from './prepareToirIssueForWidget'

const TOIR_TECH_SERVICE = `tech_service`
const TOIR_REPAIR = `toir_repair`
const TOIR_MEASUREMENT = `toir_measurement`
const TOIR_REVIEW = `tech_review`

const getIssueTypeIds = R.compose(
  R.join(`,`),
  R.map(R.prop(`id`)),
  R.filter(({ code }) => (
    code === TOIR_TECH_SERVICE
    || code === TOIR_REPAIR
    || code === TOIR_MEASUREMENT
    || code === TOIR_REVIEW
  )),
)

const apiAction = (params, issueTypes) => {
  const query = []
  const issueTypesIds = getIssueTypeIds(issueTypes)
  if (issueTypesIds) {
    query.push(`typeId=in=(${issueTypesIds})`)
  }
  if (params) {
    query.push(`id=contains=(${params})`)
  }
  return toirIssuesApiActions.fetch({ query: query.join(`;`), limit: 20, offset: 0 })
}

export const toirConfigName = `toirConfig`

const withToirIssueOnSelect = compose(
  toirStatusesTransport,
  toirIssueTypesTransport,
  withPropsOnChange([toirIssueTypesDataPropName, toirStatusesDataPropName], ({
    [toirStatusesDataPropName]: toirStatuses,
    [toirIssueTypesDataPropName]: toirIssueTypes,
  }) => ({
    [toirConfigName]: {
      valueField       : `id`,
      textField        : `id`,
      placeholder      : `Начните вводить номер заявки из ТОИР`,
      apiAction        : (params) => apiAction(params, toirIssueTypes),
      entityName       : TOIR_ISSUES_SCHEMA_NAME,
      transformLoadData: (data) => prepareToirIssueForWidget(data, toirStatuses),
    },
  }))
)


export default withToirIssueOnSelect
